import * as actionTypes from "./actionTypes";


export const update = app => ({
  type: actionTypes.UPDATE,
  app,
});
